<ng-template #legendRef let-legend="legend">
    <div class="image-container">
        <img [src]="legend.src | raskSafe" [height]="legend.height" [width]="legend.width" />
    </div>
    <div class="label-container svea-text">
        {{legend.label}}
    </div>
</ng-template>

<ng-template #nodeRef let-layer="layer">
    @let layerLegends = $any(layer.legends | async);
    @if (layer.showLegend && (layerLegends || layer.someChildHasLegends)) {
    <ul class="sub-layer">
        @if (layer.name) {
        <span class="svea-label fw-bold">{{layer.name}}</span>
        }
        @if (layerLegends && layer.showLegend && !useCustomLegend(layer)) {
        @for (legend of layerLegends; track legend.label) {
        <li>
            <ng-template
                [ngTemplateOutlet]="legendRef"
                [ngTemplateOutletContext]="{ legend: legend }">
            </ng-template>
        </li>
        }
        }
        @for (subLayer of layer.nodes; track subLayer.id) {
        <li>
            <!-- Recursive template -->
            <ng-template
                [ngTemplateOutlet]="nodeRef"
                [ngTemplateOutletContext]="{ layer: subLayer }">
            </ng-template>
        </li>
        }
    </ul>
    }
</ng-template>

<div class="legend-list">
    <ul class="layer">
        @if (useCustomLegend(root)) {
        <li>
            <ul class="sub-layer">
                <li>
                    <ng-container *ngComponentOutlet="
                                    root.customLegend.component;
                                    inputs: root.customLegend.inputs;" />
                </li>
            </ul>
        </li>
        }
        @for (node of root.nodes; track node.id) {
        <li>
            <ng-template
                [ngTemplateOutlet]="nodeRef"
                [ngTemplateOutletContext]="{ layer: node }">
            </ng-template>
        </li>
        }
    </ul>
</div>